import { Controller } from '@hotwired/stimulus';

// Scroll the host element into view (smooth) and focus the named field on
// connect. Used by `lines/create.turbo_stream.erb` to make a freshly
// appended phase row immediately visible and editable.
//
//   data-controller="autofocus"
//   data-autofocus-target="field"  // on the input that should receive focus
export default class extends Controller {
  static targets = ['field'];

  connect() {
    this.element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (this.hasFieldTarget) {
      this.fieldTarget.focus({ preventScroll: true });
    }
  }
}
